"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = require("../index");
const PanelButton = function (props) {
    const { iconName, selected, onClick, children } = props;
    return ((0, jsx_runtime_1.jsx)(StyledButton, { iconWidth: 35, iconHeight: 35, iconName: iconName, selected: selected, onClick: onClick, "data-e2e": 'StyledButton', children: children }));
};
const StyledButton = (0, styled_components_1.default)(index_1.ArModeButton) `
  width: auto;

  background: none;
  border-radius: 0;
`;
exports.default = PanelButton;
